import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import { Page, PageContent, ScrollToTopOnMount } from "frame/components";
import { useRouter } from "utils";
import AccidentCard from "../cards/accident-card";
import { EditIncidentForm } from "features/health-safety-forms";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.white,
	},
	heading: {
		marginTop: theme.spacing(4),
		[theme.breakpoints.down("xs")]: {
			marginTop: theme.spacing(0),
		},
	},
	list: {
		margin: theme.spacing(3, 0),
	},
	embeddedRoot: {
		maxHeight: "min(70vh, 720px)",
		overflowY: "auto",
	},
	embeddedContent: {
		paddingTop: theme.spacing(1),
	},
	filter: { display: "flex" },
}));

const IncidentSiteList = ({
	onDelete,
	role,
	variant = "page",
	siteId: siteIdProp,
}) => {
	const classes = useStyles();
	const { match } = useRouter();
	const siteId = siteIdProp || match?.params?.siteId;
	const isEmbedded = variant === "embedded";

	const [editId, setEditId] = useState();
	const [siteIncidents, setSiteIncidents] = useState(null);

	const incidentList = useSelector(
		({ healthSafety }) => healthSafety.incidents?.results
	);

	useEffect(() => {
		setSiteIncidents(
			incidentList && siteId
				? incidentList.filter((node) => node.siteId === siteId)
				: []
		);
	}, [incidentList, siteId]);

	const empty = siteIncidents && siteIncidents.length <= 0;

	const onEdit = (id) => () => setEditId(id);

	const onCancelEdit = () => setEditId(null);

	const body = (
		<PageContent pad className={isEmbedded ? classes.embeddedContent : undefined}>
			{!isEmbedded && (
				<Typography variant="h2" className={classes.heading}>
					Incidents
				</Typography>
			)}

			{!empty && (
				<div className={classes.list}>
					{siteIncidents &&
						siteIncidents.map((node, index) => (
							<AccidentCard
								key={index}
								accident={node}
								role={role}
								onEdit={onEdit(node.id)}
								onDelete={onDelete}
							/>
						))}
				</div>
			)}

			{empty && (
				<Typography variant="body1">
					There are currently no Incidents listed.
				</Typography>
			)}
		</PageContent>
	);

	if (isEmbedded) {
		return (
			<div className={classes.embeddedRoot}>
				{body}
				{editId && <EditIncidentForm id={editId} onClose={onCancelEdit} />}
			</div>
		);
	}

	return (
		<Page className={classes.root} title="Incidents">
			<ScrollToTopOnMount />
			{body}
			{editId && <EditIncidentForm id={editId} onClose={onCancelEdit} />}
		</Page>
	);
};

IncidentSiteList.propTypes = {
	role: PropTypes.string.isRequired,
	onDelete: PropTypes.func.isRequired,
	variant: PropTypes.oneOf(["page", "embedded"]),
	siteId: PropTypes.string,
};

export default IncidentSiteList;
